<template>
  <div class="map-time">
    <img v-if="!mapVisible" src="../assets/globe-corner.svg" @click="$emit('mapTime')" aria-hidden="true" class="map-corner">
    <img v-else src="../assets/list-corner.svg" @click="$emit('mapTime')" aria-hidden="true" class="map-corner">
  </div>
</template>

<script>
export default {
  name: 'map-flip',
  methods: {
  },
  props: {
      mapVisible: {
          type: Boolean,
          required: true
      }
  }
}
</script>

<style lang="scss" scoped>
  .map-time {
    /*
      one idea:
    display: inline-block;
    transform: translateZ(100px);
    */
    z-index: 100;
    position: absolute;
    width: 200px;
    top: 0;
    right: 0;
  }

  .map-corner {
    fill: #000;
    color: #fff;
    position: absolute;
    border: 0;
    top: 0;
    right: 0;
    height: 80px;
    width: 80px;

    &:hover {
        cursor: pointer;
    }
  };
</style>
